import React, { Fragment, useState, useEffect } from 'react';
import { GetAvailable, AddProperty, GetCurrent, AddPropDocument, AddPropRemark, AddPropInsurace, RemoveProperty } from "../../REST/agreements";
import { useForm, Controller } from "react-hook-form";
import { getOptions } from './index'
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import FormControl from '@mui/material/FormControl';
import NativeSelect from '@mui/material/NativeSelect';
import FormHelperText from '@mui/material/FormHelperText';
import InputLabel from '@mui/material/InputLabel';
import DocumentView from '../Utilities/documents';
import RemarksView from '../Utilities/remarks';
import { useParams } from 'react-router-dom';
import SecurityDeposit from './security';
import Insurance from './insurance';
import AirCraftList from './aircrafts';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import BuildIcon from '@mui/icons-material/Build';
import Access from '../../Utils/authorize';
import Confirm from "../../Utils/confirm";
import ResponsiveDialog from '../../themes/components/ResponsiveDialog';
import { useTheme, useMediaQuery } from '@mui/material';

export default function PropertyList({ isEdit, agreementId }) {
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down('md'))
    const { id } = useParams()
    const [data, setData] = useState([])
    const [mode, setMode] = useState(0)
    const [refresh, setRefresh] = useState(false)
    const [open, setOpen] = useState(false);
    const [removepropertyid,setRemovepropertyid] = useState(null);
    const [removepropertyname,setRemovepropertyname] = useState(null);
    const [activeProperty, setActiveProperty] = useState(null)
    const toggleRefresh = () => setRefresh(refresh => !refresh)
    
    const handleClose = () => {
        setOpen(false);
        setRemovepropertyid(null)
        setRemovepropertyname(null)
    };   

    const handleToolsClose = () => setActiveProperty(null)
  
    useEffect(() => {
        toggleRefresh()
    }, [])

    useEffect(() => {
        (async () => {
            const result = await GetCurrent(id)
            setData(result.data)
            setMode(0)
        })()
    }, [refresh, id])

    const handleMode = setMode

    const handleData = (data) => {
        (async () => {
            await AddProperty(id, data.name).then(toggleRefresh)
            setMode(0)
        })()
    }
   

    const addDocument = (prop, doc) => AddPropDocument(id, prop, doc).then(toggleRefresh)
    const addRemark = (prop, doc) => AddPropRemark(id, prop, doc).then(toggleRefresh)
    const addInsurance = (prop, doc) => AddPropInsurace(id, prop, doc).then(toggleRefresh)
    const removePropertyConfirm = (id,name) => { 
        setOpen(true)
        setRemovepropertyname(name)
        setRemovepropertyid(id) 
    } 
     
    return <Fragment>
        { open && <Confirm onClose={handleClose} open={open} 
                           title = {"Remove Property "+removepropertyname} 
                           onAccept={()=>{ RemoveProperty(id,removepropertyid).then(toggleRefresh)  } }/> }

        <FormDialog open={mode !== 0} data={data} handleClose={() => handleMode(0)} handleSave={handleData} />
        <Stack spacing={2}>
            {isEdit && (
                <Box sx={{ display: 'flex', justifyContent: 'flex-start' }}>
                    <Button variant="outlined" onClick={() => handleMode(1)}>Link Property</Button>
                </Box>
            )}

            {data.length === 0 && (
                <Paper variant="outlined" sx={{ p: 2 }}>
                    <Typography variant="body2" color="text.secondary">
                        No properties linked to this agreement yet.
                    </Typography>
                </Paper>
            )}

            {data.map((e, idx) => {
                const tenantHistory = e.tenants || []
                const currTenant = tenantHistory.find(each => each.agreementId === agreementId) || {}

                return (
                    <Paper key={idx} variant="outlined" sx={{ p: 2 }}>
                        <Stack spacing={2}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: { xs: 'column', sm: 'row' },
                                    justifyContent: 'space-between',
                                    gap: 1,
                                }}
                            >
                                <Box>
                                    <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                                        {e.name}
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary">
                                        Rental Amount: ${e.rent}
                                    </Typography>
                                </Box>
                                {isMobile && (
                                    <Button
                                        variant="outlined"
                                        startIcon={<BuildIcon />}
                                        onClick={() => setActiveProperty(e._id)}
                                        sx={{ alignSelf: { xs: 'flex-start', sm: 'center' } }}
                                    >
                                        Property Tools
                                    </Button>
                                )}
                            </Box>

                            {!isMobile && (
                                <Grid container spacing={1.5} alignItems="stretch">
                                    {Access.isAdmin('Property') && (
                                        <Grid item>
                                            <Button variant='outlined' startIcon={<HighlightOffIcon />} onClick={() => removePropertyConfirm(e._id,e.name)}>
                                                Remove Property
                                            </Button>
                                        </Grid>
                                    )}
                                    <Grid item>
                                        <Insurance docIds={currTenant.insurances} onUpload={x => addInsurance(e._id, x._id)} />
                                    </Grid>
                                    {Access.isAdmin('Property') && (
                                        <Grid item>
                                            <SecurityDeposit propertyId={e._id} data={currTenant.securityDeposit} toggleRefresh={toggleRefresh} />
                                        </Grid>
                                    )}
                                    <Grid item>
                                        <DocumentView module={'Property'} docIds={currTenant.documents} onUpload={x => addDocument(e._id, x._id)} />
                                    </Grid>
                                    <Grid item>
                                        <RemarksView module={'Property'} docIds={currTenant.remarks} onUpload={x => addRemark(e._id, x._id)} />
                                    </Grid>
                                    <Grid item>
                                        <AirCraftList id={e._id} agreement={agreementId} />
                                    </Grid>
                                </Grid>
                            )}
                        </Stack>

                        {isMobile && activeProperty === e._id && (
                            <ResponsiveDialog open={activeProperty === e._id} onClose={handleToolsClose}>
                                <DialogTitle>{e.name} Tools</DialogTitle>
                                <DialogContent>
                                    <DialogContentText sx={{ mb: 2 }}>
                                        Manage property records and related actions for this lease.
                                    </DialogContentText>
                                    <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                                        Rental Amount: ${e.rent}
                                    </Typography>
                                    <Divider sx={{ mb: 2 }} />
                                    <Grid container spacing={1.5} alignItems="stretch">
                                        {Access.isAdmin('Property') && (
                                            <Grid item xs={12} sm={6}>
                                                <Button
                                                    fullWidth
                                                    variant='outlined'
                                                    startIcon={<HighlightOffIcon />}
                                                    onClick={() => removePropertyConfirm(e._id,e.name)}
                                                >
                                                    Remove Property
                                                </Button>
                                            </Grid>
                                        )}
                                        <Grid item xs={12} sm={6}>
                                            <Box sx={{ display: 'flex', width: '100%' }}>
                                                <Insurance docIds={currTenant.insurances} onUpload={x => addInsurance(e._id, x._id)} />
                                            </Box>
                                        </Grid>
                                        {Access.isAdmin('Property') && (
                                            <Grid item xs={12} sm={6}>
                                                <Box sx={{ display: 'flex', width: '100%' }}>
                                                    <SecurityDeposit propertyId={e._id} data={currTenant.securityDeposit} toggleRefresh={toggleRefresh} />
                                                </Box>
                                            </Grid>
                                        )}
                                        <Grid item xs={12} sm={6}>
                                            <Box sx={{ display: 'flex', width: '100%' }}>
                                                <DocumentView module={'Property'} docIds={currTenant.documents} onUpload={x => addDocument(e._id, x._id)} />
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <Box sx={{ display: 'flex', width: '100%' }}>
                                                <RemarksView module={'Property'} docIds={currTenant.remarks} onUpload={x => addRemark(e._id, x._id)} />
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <Box sx={{ display: 'flex', width: '100%' }}>
                                                <AirCraftList id={e._id} agreement={agreementId} />
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={handleToolsClose}>Close</Button>
                                </DialogActions>
                            </ResponsiveDialog>
                        )}
                    </Paper>
                )
            })}
        </Stack>
    </Fragment>
}



function FormDialog({ open = false, handleClose, handleSave }) {

    const [types, setTypes] = useState([])

    const schema = yup.object({
        name: yup.string().trim().required()
    }).required();

    const { control, handleSubmit, formState: { errors }, clearErrors, reset } = useForm({
        defaultValues: {
            name: ''
        },
        resolver: yupResolver(schema)
    });

    useEffect(() => {
        if (open) {
            (async () => {
                const props = await GetAvailable()
                if (Array.isArray(props.data)) {
                    setTypes(props.data)
                }
            })()
            clearErrors()
            reset()
        }
    }, [open, clearErrors, reset])

    const onSubmit = handleSave

    const isError = (val) => val !== undefined && val !== null && typeof val === 'object'


    return <ResponsiveDialog open={open} onClose={handleClose}>
        <DialogTitle>Link Property</DialogTitle>
        <DialogContent>
            <DialogContentText>&nbsp;</DialogContentText>
            <Controller name="name" control={control} render={({ field }) => <FormControl error={isError(errors.name)} variant='standard'
                margin='dense' fullWidth><InputLabel shrink>Property</InputLabel><NativeSelect {...field} >{getOptions(types)}</NativeSelect>{errors.name &&
                    <FormHelperText>{errors.name.message}</FormHelperText>}</FormControl>} />
        </DialogContent>
        <DialogActions>
            <Button onClick={handleClose}>Cancel</Button>
            <Button onClick={handleSubmit(onSubmit)}>Save</Button>
        </DialogActions>
    </ResponsiveDialog>
}
